// src/utils/PNPInfo

import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const PNPNominationComponent = ({ formData, calculatePNPNominationPoints }) => (
  <Box>
    <Typography variant="h6">PNP Nomination</Typography>
    <Typography>
      A Provincial Nominee Program (PNP) nomination provides a significant boost to your CRS score by awarding an additional 600 points.
      This bonus can be a game-changer in improving your overall ranking and securing an Invitation to Apply (ITA) for permanent residency.
    </Typography>
    {formData?.pnpNomination && (
      <Typography sx={{ marginTop: 2 }}>
        Your nomination bonus: {calculatePNPNominationPoints(formData.pnpNomination)} points
      </Typography>
    )}
    <Card sx={{ marginTop: 2 }}>
      <CardContent>
        <Typography variant="subtitle1">PNP Nomination Bonus Details</Typography>
        <Typography variant="body2">
          • A successful nomination from a Canadian province or territory awards a bonus of 600 CRS points.
          <br />
          • This bonus is added directly to your total CRS score.
          <br />
          • Eligibility criteria and application processes vary by province, so check your specific province's requirements.
        </Typography>
      </CardContent>
    </Card>
  </Box>
);

export default PNPNominationComponent;
